var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":_vm.toggleVerified}},[_vm._v("\n    "+_vm._s(this.isVerified ? this.setUnverifiedLabel : this.setVerifiedLabel)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }